<template>
  <div v-if="data" class="info-page">
    <div class="info-page-body">
      <div class="info-page-body-top flex">
        <div v-if="data.coverImage" class="info-page-body-top-img flex-shrink" :style="{backgroundImage: 'url(' + 'https://img.libraryplus.bjadks.com/'+data.coverImage + ')'}" />
        <div v-else class="info-page-body-top-img flex-shrink default-img-cover" />
        <div class="info-page-body-top-tit flex-1">
          <p class="font-24 tit">{{ data.title }}</p>
          <span v-if="data.author" class="item flex">
            <p class="font-14 key flex-shrink">著者：</p>
            <p class="font-14 value flex-1">{{ data.author }}</p>
          </span>
          <span v-if="data.source" class="item flex">
            <p class="font-14 key flex-shrink">来源：</p>
            <p class="font-14 value flex-1">{{ data.source }}</p>
          </span>
          <span v-if="data.source" class="item flex">
            <p class="font-14 key flex-shrink">馆藏地：</p>
            <p class="font-14 value flex-1">{{ data.resourcePlace }}</p>
          </span>
          <span v-if="data.source" class="item flex">
            <p class="font-14 key flex-shrink">馆藏类型：</p>
            <p class="font-14 value flex-1">{{ data.resourceType }}</p>
          </span>
          <span v-if="data.source" class="item flex">
            <p class="font-14 key flex-shrink">关键词：</p>
            <p class="font-14 value flex-1">{{ data.keyWords }}</p>
          </span>
          <span v-if="data.recordTime" class="item flex">
            <p class="font-14 key flex-shrink">纪事时间：</p>
            <p :title="data.recordTime" class="font-14 value flex-1 text-line-2">{{ data.recordTime }}</p>
          </span>
          <span v-if="data.recordPlace" class="item flex">
            <p class="font-14 key flex-shrink">纪事地点：</p>
            <p :title="data.recordPlace" class="font-14 value flex-1  text-line-2">{{ data.recordPlace }}</p>
          </span>
          <span v-if="data.relatedPeople" class="item flex">
            <p class="font-14 key flex-shrink">纪事人物：</p>
            <p :title="data.relatedPeople" class="font-14 value flex-1  text-line-2">{{ data.relatedPeople }}</p>
          </span>
          <span v-if="data.recordOrg" class="item flex">
            <p class="font-14 key flex-shrink">纪事机构：</p>
            <p :title="data.recordOrg" class="font-14 value flex-1 text-line-2">{{ data.recordOrg }}</p>
          </span>
        </div>
      </div>
      <div class="info-page-body-files">
        <div class="info-page-body-files-head flex-row-center">
          <p class="line" />
          <p class="font-16 font-bold">馆藏文件</p>
        </div>
        <div class="info-page-body-files-list flex">
          <div v-for="(item, si) in data.files" :key="si" class="item flex-row-center-between">
            <span class="flex-row-center flex-1">
              <img :src="require('@/assets/img/icon-source-' + fileType(item.fileType) + '.png')">
              <p class="font-14 tit text-line-1">{{ getFileName(item.sourceFileName) }}</p>
            </span>
            <p class="font-12 cursor btn flex-shrink" @click="tocheck(si)">查看</p>
          </div>
        </div>
      </div>
      <div v-if="data.explainFile" class="info-page-body-des">
        <div class="info-page-body-files-head flex-row-center">
          <p class="line" />
          <p class="font-16 font-bold">3D链接</p>
        </div>
        <div class="info-page-body-des-3d position-relative" :class="isFull?'full':''">
          <iframe
            id="iframe"
            :src="data.explainFile"
            width="100%"
            height="100%"
            frameborder="0"
            allowfullscreen
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          />
          <div class="info-page-body-des-3d-full cursor flex-center" @click="showFull">
            <img v-if="!isFull" src="@/assets/shjk/icon-source-full.png">
            <img v-else src="@/assets/shjk/icon-source-unfull.png">
          </div>
        </div>
      </div>
      <div class="info-page-body-des">
        <div class="info-page-body-files-head flex-row-center">
          <p class="line" />
          <p class="font-16 font-bold">馆藏介绍</p>

        </div>
        <div class="info-page-body-des-text">
          <p id="text-container" class="font-16 letter-spacing">{{ data.description }}</p>
        </div>
      </div>
      <div v-if="nextBook" class="info-page-body-bottom flex-row-center">
        <p class="font-14 cursor" @click="toNext">下一篇：{{ nextBook.title }}</p>
      </div>
    </div>
    <player ref="player" />
  </div>
</template>

<script>
import { nanoid } from 'nanoid'
import Mark from 'mark.js'
import FileSaver from 'file-saver'
import { getShowPath } from '@/utils/imgpath.js'
import player from '@/components/player/index.vue'
import api from '@/api/source.js'
export default {
  components: {
    player
  },
  data() {
    return {
      isFull: false,
      nextBook: null,
      curIndex: 0,
      id: '',
      list: [],
      data: null
    }
  },
  methods: {

    showInfo(curData, index, list) {
      this.data = curData
      this.id = curData.id
      this.reuqestInfo()
      this.list = list
      if (index + 1 < list.length) {
        this.nextBook = list[index + 1]
        this.curIndex = index
      } else {
        this.nextBook = null
      }
    },
    showInfoId(id, list) {
      this.id = id
      this.list = []
      this.list = this.list.concat(list)
      this.getDataId()
    },
    getDataId() {
      api.info({
        id: this.id

      }).then(res => {
        if (res.code === 2000) {
          this.data = res.items
          this.createMarkAry()
          this.list.unshift(this.data)
          if (this.list.length > 1) {
            this.nextBook = this.list[1]
            this.curIndex = 0
          } else {
            this.nextBook = null
          }
        }
      })
    },
    reuqestInfo() {
      api.info({
        id: this.id
      }).then(res => {
        if (res.code === 2000) {
          this.data = res.items
          this.createMarkAry()
        }
      })
    },
    findAllOccurrences(str, target) {
      var occurrences = []
      var index = str.indexOf(target)
      while (index !== -1) {
        occurrences.push(index)
        index = str.indexOf(target, index + 1)
      }
      return occurrences
    },
    replaceOccurrences(mrks) {
      for (let index = 0; index < mrks.length; index++) {
        const val = mrks[index]
        const end = val.start + val.len
        for (let tem = index + 1; tem < mrks.length; tem++) {
          const sub = mrks[tem]
          const send = sub.start + sub.len
          if (val.name.indexOf(sub.name) >= 0 && sub.start < end) {
            sub.id = 0
          } else if (sub.name.indexOf(val.name) >= 0 && val.start >= sub.start && end <= send) {
            val.id = 0
          }
        }
      }
      return mrks.filter(v => v.id !== 0)
    },
    createMarkAry() {
      console.error(this.data.person)
      var mark = []
      if (this.data.person && this.data.person.length) {
        this.data.person.forEach(val => {
          const positions = this.findAllOccurrences(this.data.description, val.name)
          if (positions.length) {
            positions.forEach(v => {
              mark.push({
                mid: nanoid(10),
                start: v,
                len: val.name.length,
                id: val.id,
                color: val.color,
                name: val.name,
                code: val.catalogId
              })
            })
          }
        })
      }
      if (this.data.organization && this.data.organization.length) {
        this.data.organization.forEach(val => {
          const positions = this.findAllOccurrences(this.data.description, val.name)
          if (positions.length) {
            positions.forEach(v => {
              mark.push({
                mid: nanoid(10),
                start: v,
                len: val.name.length,
                id: val.id,
                color: val.color,
                name: val.name,
                code: val.catalogId
              })
            })
          }
        })
      }
      if (this.data.place && this.data.place.length) {
        this.data.place.forEach(val => {
          const positions = this.findAllOccurrences(this.data.description, val.name)
          if (positions.length) {
            positions.forEach(v => {
              mark.push({
                mid: nanoid(10),
                start: v,
                len: val.name.length,
                id: val.id,
                color: val.color,
                name: val.name,
                code: val.catalogId
              })
            })
          }
        })
      }
      if (this.data.recordTime) {
        const sy = this.data.recordTime.split(',')
        console.error(sy)
        sy.forEach(val => {
          const positions = this.findAllOccurrences(this.data.description, val)
          if (positions.length) {
            positions.forEach(v => {
              mark.push({
                mid: nanoid(10),
                start: v,
                len: val.length,
                id: -1,
                color: '#e6a23c',
                name: val,
                code: 0
              })
            })
          }
        })
      }
      mark = this.replaceOccurrences(mark)
      console.error(mark)
      if (mark.length) {
        this.createMarker(mark)
      }
    },

    createMarker(mrks) {
      const that = this
      const marker = new Mark(document.getElementById('text-container'))
      mrks.forEach(item => {
        marker.markRanges([{ start: item.start,
          length: item.len }], {
          element: 'span',
          className: item.id !== -1 ? 'text-selected' : 'none',
          each: (element) => {
            element.setAttribute('id', item.mid)
            element.style.color = item.color
            element.onclick = function(e) {
              e.preventDefault()
              console.error(e.target.id)
              const restult = mrks.filter(v => v.mid === e.target.id)
              if (restult.length) {
                const { id, code } = restult[0]
                if (id === -1) {
                  return
                }
                const page = that.$router.resolve({
                  path: '/entity',
                  query: {
                    cateId: code,
                    sourceId: id
                  }
                })
                window.open(page.href, '_blank')
              }
            }
          }
        })
      })
    },
    fileType(str) {
      if (str) {
        if (str.indexOf('image') > -1) {
          return 'img'
        }
        if (str.indexOf('zip') >= 0) {
          return 'zip'
        }
        if (str.indexOf('video') >= 0) {
          return 'video'
        }
        if (str.indexOf('pdf') >= 0) {
          return 'pdf'
        }
        if (str.indexOf('audio') >= 0) {
          return 'audio'
        }
        if (str.indexOf('word') >= 0) {
          return 'word'
        }
        if (str.indexOf('xlsx') >= 0) {
          return 'xlsx'
        }
        if (str.indexOf('pptx') >= 0) {
          return 'ppt'
        }
      }

      return 'unkown'
    },
    getFileName(str) {
      return str.split('/').pop()
    },
    downFile() {
      const url = getShowPath('pdf', this.data.pdf)
      FileSaver.saveAs(url, this.data.bookName)
    },
    tocheck(val) {
      const data = this.data.files[val]

      const fileType = this.fileType(data.fileType)
      if (fileType === 'img') {
        const listimage = this.data.files.filter(item => {
          return item.fileType.indexOf('image') > -1
        })
        const ary = listimage.map(v => 'https://img.libraryplus.bjadks.com/' + v.savePath)
        const index = ary.findIndex(v => v === ('https://img.libraryplus.bjadks.com/' + data.savePath))
        this.$viewerApi({
          images: ary,
          options: {
            initialViewIndex: index
          }
        })
      } else if (fileType === 'pdf' || fileType === 'word') {
        window.open('https://v.libraryplus.bjadks.com/' + data.savePath, '__blank')
      } else if (fileType === 'video' || fileType === 'audio') {
        const ary = this.data.files.filter(
          (v) => v.fileType.indexOf('audio') > -1 || v.fileType.indexOf('video') > -1
        )
        console.log(ary)
        const index = ary.findIndex(v => v.id === data.id)
        this.$refs.player.showFull(ary, index)
        document.body.style.overflow = this.isFull ? 'hidden' : 'auto'
      }
    },
    toNext() {
      this.curIndex += 1
      if (this.curIndex + 1 < this.list.length) {
        this.nextBook = this.list[this.curIndex + 1]
      } else {
        this.nextBook = null
      }
      this.data = this.list[this.curIndex]
    },
    showFull() {
      this.isFull = !this.isFull
    }
  }
}
</script>

<style>

.info-page {
  padding: 20px 0 60px;
}

.info-page-body-top {
  margin-bottom: 30px;
  overflow: hidden;
}

.info-page-body-top-img {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 340px;
  height: 240px;
  margin-right: 20px;
  border-radius: 3px;
}

.info-page-body-top-tit .tit {
  color: #1A1A1A;
  line-height: 36px;
  margin-bottom: 10px;
  word-break: break-all;
}

.info-page-body-top-tit .item {
  margin-bottom: 10px;
}

.info-page-body-top-tit .item .key {
  width: 80px;
  line-height: 22px;
  color: #767676;
}

.info-page-body-top-tit {
  overflow: hidden;
}

.info-page-body-top-tit .item .value {
  line-height: 22px;
  color: #1A1A1A;
  word-break: break-all;
}

.info-page-body-files {
  margin-bottom: 30px;
}

.info-page-body-files-head {
  height: 50px;
}

.info-page-body-files-head .line {
  background: #B21F12;
  width: 4px;
  height: 16px;
  margin-right: 6px;
}

.info-page-body-files-head p {
  color: #B21F12;
}

.info-page-body-files-list {
  flex-wrap: wrap;
}

.info-page-body-files-list .item {
  width: calc(50% - 5px);
  height: 40px;
  border-radius: 5px;
  background: #F7F7F7;
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 0 15px;
}

.info-page-body-files-list .item:nth-child(2n) {
  margin-right: 0;
}

.info-page-body-files-list .item img {
  margin-right: 10px;
}

.info-page-body-files-list .item .tit {
  color: #1A1A1A;
}

.info-page-body-files-list .item .btn {
  color: #767676;
  margin-left: 10px;
}

.info-page-body-des {
  margin-bottom: 30px;
}

.info-page-body-des-text p{
  line-height: 32px;
  color: #1A1A1A;
  white-space: pre-wrap;
  word-break: break-all;
}

.info-page-body-bottom {
  margin-top: 60px;
  border-top: 1px solid #eee;
  height: 50px;
}

.info-page-body-bottom p {
  color: #1A1A1A;
}

.info-page-body-des-3d-full {
  position: absolute;
  width: 30px;
  height: 30px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
  right: 10px;
  top: 10px;
  z-index: 99;
}

.info-page-body-des-3d {
  height: 500px;
}

.info-page-body-des-3d.full {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: auto;
}

.text-selected {
  cursor: pointer;
}

</style>
